const countryData = {
  "Antioquia": {
    "Medellín": "05001000",
    "Abejorral": "05002000",
    "Alejandría": "05021000",
    "Amagá": "05030000",
    "Amalfi": "05031000",
    "Andes": "05034000",
    "Angelópolis": "05036000",
    "Angostura": "05038000",
    "Anorí": "05040000",
    "Santa Fé De Antioquia": "05042000",
    "Anzá": "05044000",
    "Apartadó": "05045000",
    "Arboletes": "05051000",
    "Argelia": "05055000",
    "Armenia": "05059000",
    "Barbosa": "05079000",
    "Belmira": "05086000",
    "Bello": "05088000",
    "Betania": "05091000",
    "Betulia": "05093000",
    "Ciudad Bolívar": "05101000",
    "Buriticá": "05113000",
    "Cáceres": "05120000",
    "Caicedo": "05125000",
    "Caldas": "05129000",
    "Campamento": "05134000",
    "Cañasgordas": "05138000",
    "Caramanta": "05145000",
    "Carepa": "05147000",
    "El Carmen De Viboral": "05148000",
    "Carolina": "05150000",
    "Caucasia": "05154000",
    "Chigorodó": "05172000",
    "Cisneros": "05190000",
    "Cocorná": "05197000",
    "Concordia": "05209000",
    "Copacabana": "05212000",
    "Dabeiba": "05234000",
    "Donmatías": "05237000",
    "El Bagre": "05250000",
    "Entrerríos": "05264000",
    "Envigado": "05266000",
    "Fredonia": "05282000",
    "Frontino": "05284000",
    "Giraldo": "05306000",
    "Girardota": "05308000",
    "Gómez Plata": "05310000",
    "Granada": "05313000",
    "Guarne": "05318000",
    "Guatapé": "05321000",
    "Heliconia": "05347000",
    "Itagüí": "05360000",
    "Ituango": "05361000",
    "Jardín": "05364000",
    "Jericó": "05368000",
    "La Ceja": "05376000",
    "La Estrella": "05380000",
    "La Pintada": "05390000",
    "La Unión": "05400000",
    "Liborina": "05411000",
    "Maceo": "05425000",
    "Marinilla": "05440000",
    "Montebello": "05467000",
    "Mutatá": "05480000",
    "Nariño": "05483000",
    "Necoclí": "05490000",
    "Nechí": "05495000",
    "Olaya": "05501000",
    "Peñol": "05541000",
    "Peque": "05543000",
    "Pueblorrico": "05576000",
    "Puerto Berrío": "05579000",
    "Puerto Nare": "05585000",
    "Puerto Triunfo": "05591000",
    "Remedios": "05604000",
    "Retiro": "05607000",
    "Rionegro": "05615000",
    "Sabanalarga": "05628000",
    "Sabaneta": "05631000",
    "Salgar": "05642000",
    "San Andrés De Cuerquía": "05647000",
    "San Carlos": "05649000",
    "San Francisco": "05652000",
    "San Jerónimo": "05656000",
    "San José De La Montaña": "05658000",
    "San Juan De Urabá": "05659000",
    "San Luis": "05660000",
    "San Pedro De Los Milagros": "05664000",
    "San Pedro De Urabá": "05665000",
    "San Rafael": "05667000",
    "San Roque": "05670000",
    "San Vicente Ferrer": "05674000",
    "Santa Bárbara": "05679000",
    "Santa Rosa De Osos": "05686000",
    "Santo Domingo": "05690000",
    "El Santuario": "05697000",
    "Segovia": "05736000",
    "Sonsón": "05756000",
    "Sopetrán": "05761000",
    "Támesis": "05789000",
    "Tarazá": "05790000",
    "Toledo": "05819000",
    "Turbo": "05837000",
    "Uramita": "05842000",
    "Urrao": "05847000",
    "Valparaíso": "05856000",
    "Vegachí": "05858000",
    "Venecia": "05861000",
    "Yalí": "05885000",
    "Yarumal": "05887000",
    "Yolombó": "05890000",
    "Yondó": "05893000",
    "Zaragoza": "05895000",
    "Bajira - Mutata": "05480005"
  },
  "Atlántico": {
    "Barranquilla": "08001000",
    "Baranoa": "08078000",
    "Campo De La Cruz": "08137000",
    "Candelaria": "08141000",
    "Galapa": "08296000",
    "Juan De Acosta": "08372000",
    "Luruaco": "08421000",
    "Malambo": "08433000",
    "Manati": "08436000",
    "Palmar De Varela": "08520000",
    "Polonuevo": "08558000",
    "Ponedera": "08560000",
    "Puerto Colombia": "08573000",
    "Repelon": "08606000",
    "Sabanagrande": "08634000",
    "Sabanalarga": "08638000",
    "Santa Lucia": "08675000",
    "Santo Tomas": "08685000",
    "Soledad": "08758000",
    "Suan": "08770000",
    "Usiacuri": "08849000"
  },
  "Bogotá, D.C.": {
    "Bogotá, D.c.": "11001000"
  },
  "Bolivar": {
    "Cartagena": "13001000",
    "Achi": "13006000",
    "Arenal": "13042000",
    "Arjona": "13052000",
    "Barranco De Loba": "13074000",
    "Calamar": "13140000",
    "Cantagallo": "13160000",
    "Cicuco": "13188000",
    "Clemencia": "13222000",
    "El Carmen De Bolivar": "13244000",
    "Hatillo De Loba": "13300000",
    "Magangue": "13430000",
    "Maria La Baja": "13442000",
    "Santa Cruz De Mompox": "13468000",
    "Morales": "13473000",
    "Regidor": "13580000",
    "Rio Viejo": "13600000",
    "San Estanislao": "13647000",
    "San Jacinto": "13654000",
    "San Juan Nepomuceno": "13657000",
    "San Martin De Loba": "13667000",
    "San Pablo": "13670000",
    "Santa Rosa": "13683000",
    "Santa Rosa Del Sur": "13688000",
    "Simiti": "13744000",
    "Talaigua Nuevo": "13780000",
    "Turbaco": "13836000",
    "Turbana": "13838000",
    "Villanueva": "13873000",
    "Monte Cristo": "13458000",
    "San Cristobal": "13620000",
    "Tiquisio": "13810000",
    "Tiquisio Nuevo": "13810011"
  },
  "Boyaca": {
    "Tunja": "15001000",
    "Aquitania": "15047000",
    "Arcabuco": "15051000",
    "Belen": "15087000",
    "Beteitiva": "15092000",
    "Boavita": "15097000",
    "Buenavista": "15109000",
    "Campohermoso": "15135000",
    "Chinavita": "15172000",
    "Chiquinquira": "15176000",
    "Chiscas": "15180000",
    "Chita": "15183000",
    "Chitaraque": "15185000",
    "Chivata": "15187000",
    "Cienega": "15189000",
    "Combita": "15204000",
    "Covarachia": "15218000",
    "Cubara": "15223000",
    "Cucaita": "15224000",
    "Cuitiva": "15226000",
    "Duitama": "15238000",
    "El Cocuy": "15244000",
    "El Espino": "15248000",
    "Firavitoba": "15272000",
    "Floresta": "15276000",
    "Gameza": "15296000",
    "Garagoa": "15299000",
    "Guacamayas": "15317000",
    "Guateque": "15322000",
    "Guayata": "15325000",
    "Güican De La Sierra": "15332000",
    "Iza": "15362000",
    "Jenesano": "15367000",
    "Labranzagrande": "15377000",
    "La Capilla": "15380000",
    "La Uvita": "15403000",
    "Villa De Leyva": "15407000",
    "Macanal": "15425000",
    "Maripi": "15442000",
    "Miraflores": "15455000",
    "Mongua": "15464000",
    "Mongui": "15466000",
    "Moniquira": "15469000",
    "Motavita": "15476000",
    "Muzo": "15480000",
    "Nobsa": "15491000",
    "Nuevo Colon": "15494000",
    "Oicata": "15500000",
    "Otanche": "15507000",
    "Pachavita": "15511000",
    "Paez": "15514000",
    "Paipa": "15516000",
    "Pajarito": "15518000",
    "Panqueba": "15522000",
    "Pauna": "15531000",
    "Paz De Rio": "15537000",
    "Pesca": "15542000",
    "Puerto Boyaca": "15572000",
    "Quipama": "15580000",
    "Ramiriqui": "15599000",
    "Raquira": "15600000",
    "Rondon": "15621000",
    "Saboya": "15632000",
    "Sachica": "15638000",
    "Samaca": "15646000",
    "San Eduardo": "15660000",
    "San Jose De Pare": "15664000",
    "San Luis De Gaceno": "15667000",
    "San Mateo": "15673000",
    "San Pablo De Borbur": "15681000",
    "Santa Maria": "15690000",
    "Santa Rosa De Viterbo": "15693000",
    "Santa Sofia": "15696000",
    "Sativanorte": "15720000",
    "Sativasur": "15723000",
    "Siachoque": "15740000",
    "Soata": "15753000",
    "Socota": "15755000",
    "Socha": "15757000",
    "Sogamoso": "15759000",
    "Somondoco": "15761000",
    "Sora": "15762000",
    "Sotaquira": "15763000",
    "Soraca": "15764000",
    "Susacon": "15774000",
    "Sutamarchan": "15776000",
    "Sutatenza": "15778000",
    "Tasco": "15790000",
    "Tenza": "15798000",
    "Tibana": "15804000",
    "Tibasosa": "15806000",
    "Tinjaca": "15808000",
    "Tipacoque": "15810000",
    "Toca": "15814000",
    "Topaga": "15820000",
    "Tunungua": "15832000",
    "Turmeque": "15835000",
    "Tuta": "15837000",
    "Umbita": "15842000",
    "Ventaquemada": "15861000",
    "Viracacha": "15879000",
    "Zetaquira": "15897000"
  },
  "Caldas": {
    "Manizales": "17001000",
    "Aguadas": "17013000",
    "Anserma": "17042000",
    "Aranzazu": "17050000",
    "Belalcazar": "17088000",
    "Chinchina": "17174000",
    "Filadelfia": "17272000",
    "La Dorada": "17380000",
    "La Merced": "17388000",
    "Manzanares": "17433000",
    "Marmato": "17442000",
    "Marquetalia": "17444000",
    "Marulanda": "17446000",
    "Neira": "17486000",
    "Norcasia": "17495000",
    "Pacora": "17513000",
    "Palestina": "17524000",
    "Pensilvania": "17541000",
    "Riosucio": "17614000",
    "Risaralda": "17616000",
    "Salamina": "17653000",
    "Samana": "17662000",
    "Supia": "17777000",
    "Victoria": "17867000",
    "Villamaria": "17873000",
    "Viterbo": "17877000"
  },
  "Caqueta": {
    "Florencia": "18001000",
    "Albania": "18029000",
    "Cartagena Del Chaira": "18150000",
    "Curillo": "18205000",
    "El Doncello": "18247000",
    "El Paujil": "18256000",
    "La Montañita": "18410000",
    "Milan": "18460000",
    "Morelia": "18479000",
    "Puerto Rico": "18592000",
    "San Jose Del Fragua": "18610000",
    "San Vicente Del Caguan": "18753000",
    "Valparaiso": "18860000"
  },
  "Cauca": {
    "Popayan": "19001000",
    "Argelia": "19050000",
    "Balboa": "19075000",
    "Bolivar": "19100000",
    "Cajibio": "19130000",
    "Caldono": "19137000",
    "Caloto": "19142000",
    "Corinto": "19212000",
    "El Tambo": "19256000",
    "Florencia": "19290000",
    "Guapi": "19318000",
    "Inza": "19355000",
    "Mercaderes": "19450000",
    "Miranda": "19455000",
    "Morales": "19473000",
    "Padilla": "19513000",
    "Patia": "19532000",
    "Piamonte": "19533000",
    "Piendamo - Tunia": "19548000",
    "Puerto Tejada": "19573000",
    "Rosas": "19622000",
    "Santander De Quilichao": "19698000",
    "Silvia": "19743000",
    "Suarez": "19780000",
    "Sucre": "19785000",
    "Timbio": "19807000",
    "Timbiqui": "19809000",
    "Toribio": "19821000",
    "Totoro": "19824000",
    "Villa Rica": "19845000",
    "El Plateado": "19050006"
  },
  "Cesar": {
    "Valledupar": "20001000",
    "Aguachica": "20011000",
    "Agustin Codazzi": "20013000",
    "Astrea": "20032000",
    "Becerril": "20045000",
    "Bosconia": "20060000",
    "Chimichagua": "20175000",
    "Chiriguana": "20178000",
    "Curumani": "20228000",
    "El Copey": "20238000",
    "El Paso": "20250000",
    "Gamarra": "20295000",
    "La Gloria": "20383000",
    "La Jagua De Ibirico": "20400000",
    "Pailitas": "20517000",
    "Pelaya": "20550000",
    "Pueblo Bello": "20570000",
    "Rio De Oro": "20614000",
    "La Paz": "20621000",
    "San Alberto": "20710000",
    "San Diego": "20750000",
    "San Martin": "20770000",
    "Tamalameque": "20787000"
  },
  "Cordoba": {
    "Monteria": "23001000",
    "Ayapel": "23068000",
    "Buenavista": "23079000",
    "Cerete": "23162000",
    "Chinu": "23182000",
    "Cienaga De Oro": "23189000",
    "Cotorra": "23300000",
    "La Apartada": "23350000",
    "Lorica": "23417000",
    "Montelibano": "23466000",
    "Planeta Rica": "23555000",
    "Pueblo Nuevo": "23570000",
    "Puerto Escondido": "23574000",
    "Puerto Libertador": "23580000",
    "Purisima De La Concepcion": "23586000",
    "Sahagun": "23660000",
    "San Antero": "23672000",
    "San Bernardo Del Viento": "23675000",
    "San Pelayo": "23686000",
    "Valencia": "23855000"
  },
  "Cundinamarca": {
    "Agua De Dios": "25001000",
    "Alban": "25019000",
    "Anapoima": "25035000",
    "Anolaima": "25040000",
    "Arbelaez": "25053000",
    "Bituima": "25095000",
    "Bojaca": "25099000",
    "Cabrera": "25120000",
    "Cachipay": "25123000",
    "Cajica": "25126000",
    "Caparrapi": "25148000",
    "Caqueza": "25151000",
    "Carmen De Carupa": "25154000",
    "Chaguani": "25168000",
    "Chia": "25175000",
    "Chipaque": "25178000",
    "Choachi": "25181000",
    "Choconta": "25183000",
    "Cogua": "25200000",
    "Cota": "25214000",
    "Cucunuba": "25224000",
    "El Colegio": "25245000",
    "El Peñon": "25258000",
    "El Rosal": "25260000",
    "Facatativa": "25269000",
    "Fomeque": "25279000",
    "Fosca": "25281000",
    "Funza": "25286000",
    "Fuquene": "25288000",
    "Fusagasuga": "25290000",
    "Gachala": "25293000",
    "Gachancipa": "25295000",
    "Gacheta": "25297000",
    "Gama": "25299000",
    "Girardot": "25307000",
    "Granada": "25312000",
    "Guacheta": "25317000",
    "Guaduas": "25320000",
    "Guasca": "25322000",
    "Guatavita": "25326000",
    "Guayabal De Siquima": "25328000",
    "Guayabetal": "25335000",
    "Gutierrez": "25339000",
    "Jerusalen": "25368000",
    "Junin": "25372000",
    "La Calera": "25377000",
    "La Mesa": "25386000",
    "La Palma": "25394000",
    "La Vega": "25402000",
    "Lenguazaque": "25407000",
    "Macheta": "25426000",
    "Madrid": "25430000",
    "Manta": "25436000",
    "Medina": "25438000",
    "Mosquera": "25473000",
    "Nariño": "25483000",
    "Nemocon": "25486000",
    "Nilo": "25488000",
    "Nocaima": "25491000",
    "Venecia": "25506000",
    "Pacho": "25513000",
    "Paime": "25518000",
    "Paratebueno": "25530000",
    "Pasca": "25535000",
    "Puerto Salgar": "25572000",
    "Puli": "25580000",
    "Quebradanegra": "25592000",
    "Quetame": "25594000",
    "Quipile": "25596000",
    "Apulo": "25599000",
    "Ricaurte": "25612000",
    "San Antonio Del Tequendama": "25645000",
    "San Bernardo": "25649000",
    "San Juan De Rioseco": "25662000",
    "Sasaima": "25718000",
    "Sesquile": "25736000",
    "Sibate": "25740000",
    "Silvania": "25743000",
    "Simijaca": "25745000",
    "Soacha": "25754000",
    "Sopo": "25758000",
    "Subachoque": "25769000",
    "Suesca": "25772000",
    "Supata": "25777000",
    "Susa": "25779000",
    "Sutatausa": "25781000",
    "Tabio": "25785000",
    "Tausa": "25793000",
    "Tena": "25797000",
    "Tenjo": "25799000",
    "Tibacuy": "25805000",
    "Tibirita": "25807000",
    "Tocaima": "25815000",
    "Tocancipa": "25817000",
    "Topaipi": "25823000",
    "Ubala": "25839000",
    "Ubaque": "25841000",
    "Villa De San Diego De Ubate": "25843000",
    "Une": "25845000",
    "Utica": "25851000",
    "Vergara": "25862000",
    "Viani": "25867000",
    "Villagomez": "25871000",
    "Villapinzon": "25873000",
    "Villeta": "25875000",
    "Viota": "25878000",
    "Yacopi": "25885000",
    "Zipacon": "25898000",
    "Zipaquira": "25899000",
    "San Francisco": "25372008"
  },
  "Choco": {
    "Quibdo": "27001000",
    "Bahia Solano": "27075000",
    "Certegui": "27160000",
    "Condoto": "27205000",
    "El Carmen De Atrato": "27245000",
    "Istmina": "27361000",
    "Lloro": "27413000",
    "Novita": "27491000",
    "Riosucio": "27615000",
    "Tado": "27787000"
  },
  "Huila": {
    "Neiva": "41001000",
    "Acevedo": "41006000",
    "Agrado": "41013000",
    "Aipe": "41016000",
    "Algeciras": "41020000",
    "Altamira": "41026000",
    "Baraya": "41078000",
    "Campoalegre": "41132000",
    "Colombia": "41206000",
    "Garzon": "41298000",
    "Gigante": "41306000",
    "Guadalupe": "41319000",
    "Hobo": "41349000",
    "Iquira": "41357000",
    "San Jose De Isnos": "41359000",
    "La Argentina": "41378000",
    "La Plata": "41396000",
    "Nataga": "41483000",
    "Oporapa": "41503000",
    "Paicol": "41518000",
    "Palermo": "41524000",
    "Palestina": "41530000",
    "Pital": "41548000",
    "Pitalito": "41551000",
    "Rivera": "41615000",
    "San Agustin": "41668000",
    "Santa Maria": "41676000",
    "Suaza": "41770000",
    "Tarqui": "41791000",
    "Tesalia": "41797000",
    "Tello": "41799000",
    "Teruel": "41801000",
    "Timana": "41807000",
    "Villavieja": "41872000",
    "Yaguara": "41885000"
  },
  "La Guajira": {
    "Riohacha": "44001000",
    "Albania": "44035000",
    "Barrancas": "44078000",
    "Dibulla": "44090000",
    "Distracción": "44098000",
    "El Molino": "44110000",
    "Fonseca": "44279000",
    "Hatonuevo": "44378000",
    "Maicao": "44430000",
    "Manaure": "44560000",
    "San Juan Del Cesar": "44650000",
    "Uribia": "44847000",
    "Urumita": "44855000",
    "Villanueva": "44874000",
    "Buenavista": "44099000"
  },
  "Magdalena": {
    "Santa Marta": "47001000",
    "Aracataca": "47053000",
    "Ariguani": "47058000",
    "Chivolo": "47170000",
    "Cienaga": "47189000",
    "El Banco": "47245000",
    "El Reten": "47268000",
    "Fundacion": "47288000",
    "Guamal": "47318000",
    "Nueva Granada": "47460000",
    "Pivijay": "47551000",
    "Plato": "47555000",
    "San Sebastian De Buenavista": "47692000",
    "Santa Ana": "47707000",
    "Tenerife": "47798000",
    "San Angel": "47660000",
    "Sevilla": "47980000"
  },
  "Meta": {
    "Villavicencio": "50001000",
    "Acacias": "50006000",
    "Barranca De Upia": "50110000",
    "Cabuyaro": "50124000",
    "Castilla La Nueva": "50150000",
    "Cubarral": "50223000",
    "Cumaral": "50226000",
    "El Castillo": "50251000",
    "El Dorado": "50270000",
    "Fuente De Oro": "50287000",
    "Granada": "50313000",
    "Guamal": "50318000",
    "Mapiripan": "50325000",
    "Mesetas": "50330000",
    "La Macarena": "50350000",
    "Uribe": "50370000",
    "Lejanias": "50400000",
    "Puerto Concordia": "50450000",
    "Puerto Gaitan": "50568000",
    "Puerto Lopez": "50573000",
    "Puerto Rico": "50590000",
    "Restrepo": "50606000",
    "San Carlos De Guaroa": "50680000",
    "San Juan De Arama": "50683000",
    "San Juanito": "50686000",
    "San Martin": "50689000",
    "Vistahermosa": "50711000"
  },
  "Nariño": {
    "Pasto": "52001000",
    "Ancuya": "52036000",
    "Barbacoas": "52079000",
    "Belen": "52083000",
    "Buesaco": "52110000",
    "Consaca": "52207000",
    "Contadero": "52210000",
    "Cordoba": "52215000",
    "Cuaspud Carlosama": "52224000",
    "Cumbal": "52227000",
    "Chachagüi": "52240000",
    "El Rosario": "52256000",
    "El Tablon De Gomez": "52258000",
    "El Tambo": "52260000",
    "Funes": "52287000",
    "Guachucal": "52317000",
    "Guaitarilla": "52320000",
    "Gualmatan": "52323000",
    "Iles": "52352000",
    "Imues": "52354000",
    "Ipiales": "52356000",
    "La Cruz": "52378000",
    "La Florida": "52381000",
    "La Llanada": "52385000",
    "La Union": "52399000",
    "Linares": "52411000",
    "Los Andes": "52418000",
    "Nariño": "52480000",
    "Policarpa": "52540000",
    "Potosi": "52560000",
    "Providencia": "52565000",
    "Pupiales": "52585000",
    "Ricaurte": "52612000",
    "Samaniego": "52678000",
    "Sandona": "52683000",
    "San Bernardo": "52685000",
    "San Lorenzo": "52687000",
    "San Pablo": "52693000",
    "San Pedro De Cartago": "52694000",
    "Taminango": "52786000",
    "Tangua": "52788000",
    "Tumaco": "52835000",
    "Tuquerres": "52838000",
    "Yacuanquer": "52885000",
    "Payan": "52427000",
    "Ricaurte": "52427006",
    "Bocas De Satinga": "52490000",
    "Iscuande": "52696000"
  },
  "Norte De Santander": {
    "San Jose De Cucuta": "54001000",
    "Abrego": "54003000",
    "Arboledas": "54051000",
    "Bochalema": "54099000",
    "Bucarasica": "54109000",
    "Cacota": "54125000",
    "Cachira": "54128000",
    "Chinacota": "54172000",
    "Chitaga": "54174000",
    "Convencion": "54206000",
    "Cucutilla": "54223000",
    "El Carmen": "54245000",
    "El Zulia": "54261000",
    "La Esperanza": "54385000",
    "Los Patios": "54405000",
    "Mutiscua": "54480000",
    "Ocaña": "54498000",
    "Pamplona": "54518000",
    "Pamplonita": "54520000",
    "Puerto Santander": "54553000",
    "Ragonvalia": "54599000",
    "Salazar": "54660000",
    "Sardinata": "54720000",
    "Silos": "54743000",
    "Tibu": "54810000",
    "Toledo": "54820000",
    "Villa Del Rosario": "54874000"
  },
  "Quindio": {
    "Armenia": "63001000",
    "Calarca": "63130000",
    "Circasia": "63190000",
    "Cordoba": "63212000",
    "Filandia": "63272000",
    "Genova": "63302000",
    "La Tebaida": "63401000",
    "Montenegro": "63470000",
    "Quimbaya": "63594000",
    "Salento": "63690000"
  },
  "Risaralda": {
    "Pereira": "66001000",
    "Apia": "66045000",
    "Belen De Umbria": "66088000",
    "Dosquebradas": "66170000",
    "Guatica": "66318000",
    "La Celia": "66383000",
    "La Virginia": "66400000",
    "Marsella": "66440000",
    "Mistrato": "66456000",
    "Pueblo Rico": "66572000",
    "Quinchia": "66594000",
    "Santa Rosa De Cabal": "66682000",
    "Santuario": "66687000"
  },
  "Santander": {
    "Bucaramanga": "68001000",
    "Albania": "68020000",
    "Aratoca": "68051000",
    "Barbosa": "68077000",
    "Barichara": "68079000",
    "Barrancabermeja": "68081000",
    "Betulia": "68092000",
    "Bolivar": "68101000",
    "California": "68132000",
    "Capitanejo": "68147000",
    "Carcasi": "68152000",
    "Cerrito": "68162000",
    "Charala": "68167000",
    "Charta": "68169000",
    "Chima": "68176000",
    "Cimitarra": "68190000",
    "Concepcion": "68207000",
    "Confines": "68209000",
    "Contratacion": "68211000",
    "Coromoro": "68217000",
    "Curiti": "68229000",
    "El Carmen De Chucuri": "68235000",
    "El Guacamayo": "68245000",
    "El Peñon": "68250000",
    "El Playon": "68255000",
    "Enciso": "68266000",
    "Florian": "68271000",
    "Floridablanca": "68276000",
    "Galan": "68296000",
    "Gambita": "68298000",
    "Giron": "68307000",
    "Guaca": "68318000",
    "Guadalupe": "68320000",
    "Güepsa": "68327000",
    "Jesus Maria": "68368000",
    "La Belleza": "68377000",
    "Landazuri": "68385000",
    "La Paz": "68397000",
    "Lebrija": "68406000",
    "Los Santos": "68418000",
    "Malaga": "68432000",
    "Matanza": "68444000",
    "Mogotes": "68464000",
    "Molagavita": "68468000",
    "Oiba": "68500000",
    "Onzaga": "68502000",
    "Piedecuesta": "68547000",
    "Pinchote": "68549000",
    "Puente Nacional": "68572000",
    "Puerto Parra": "68573000",
    "Puerto Wilches": "68575000",
    "Rionegro": "68615000",
    "Sabana De Torres": "68655000",
    "San Andres": "68669000",
    "San Gil": "68679000",
    "San Joaquin": "68682000",
    "San Jose De Miranda": "68684000",
    "San Vicente De Chucuri": "68689000",
    "Santa Barbara": "68705000",
    "Santa Helena Del Opon": "68720000",
    "Simacota": "68745000",
    "Socorro": "68755000",
    "Suaita": "68770000",
    "Sucre": "68773000",
    "Surata": "68780000",
    "Tona": "68820000",
    "Valle De San Jose": "68855000",
    "Velez": "68861000",
    "Vetas": "68867000",
    "Villanueva": "68872000",
    "Zapatoca": "68895000",
    "Macaravita": "68425000"
  },
  "Sucre": {
    "Sincelejo": "70001000",
    "Caimito": "70124000",
    "Corozal": "70215000",
    "Coveñas": "70221000",
    "Galeras": "70235000",
    "Guaranda": "70265000",
    "La Union": "70400000",
    "Majagual": "70429000",
    "Morroa": "70473000",
    "Ovejas": "70508000",
    "Sampues": "70670000",
    "San Marcos": "70708000",
    "San Onofre": "70713000",
    "San Pedro": "70717000",
    "Sucre": "70771000",
    "Santiago De Tolu": "70820000"
  },
  "Tolima": {
    "Ibague": "73001000",
    "Alpujarra": "73024000",
    "Alvarado": "73026000",
    "Ambalema": "73030000",
    "Anzoategui": "73043000",
    "Armero": "73055000",
    "Ataco": "73067000",
    "Cajamarca": "73124000",
    "Carmen De Apicala": "73148000",
    "Casabianca": "73152000",
    "Chaparral": "73168000",
    "Coyaima": "73217000",
    "Cunday": "73226000",
    "Dolores": "73236000",
    "Espinal": "73268000",
    "Falan": "73270000",
    "Flandes": "73275000",
    "Fresno": "73283000",
    "Guamo": "73319000",
    "Herveo": "73347000",
    "Honda": "73349000",
    "Icononzo": "73352000",
    "Lerida": "73408000",
    "Libano": "73411000",
    "Mariquita": "73443000",
    "Melgar": "73449000",
    "Murillo": "73461000",
    "Natagaima": "73483000",
    "Ortega": "73504000",
    "Palocabildo": "73520000",
    "Piedras": "73547000",
    "Planadas": "73555000",
    "Prado": "73563000",
    "Purificacion": "73585000",
    "Rioblanco": "73616000",
    "Roncesvalles": "73622000",
    "Rovira": "73624000",
    "Saldaña": "73671000",
    "San Antonio": "73675000",
    "San Luis": "73678000",
    "Santa Isabel": "73686000",
    "Valle De San Juan": "73854000",
    "Venadillo": "73861000",
    "Villarrica": "73873000",
    "Santiago Perez": "73067007",
    "Herrera": "73616001"
  },
  "Valle Del Cauca": {
    "Cali": "76001000",
    "Alcala": "76020000",
    "Andalucia": "76036000",
    "Ansermanuevo": "76041000",
    "Argelia": "76054000",
    "Buenaventura": "76109000",
    "Guadalajara De Buga": "76111000",
    "Bugalagrande": "76113000",
    "Caicedonia": "76122000",
    "Calima": "76126000",
    "Candelaria": "76130000",
    "Cartago": "76147000",
    "Dagua": "76233000",
    "El Aguila": "76243000",
    "El Cairo": "76246000",
    "El Cerrito": "76248000",
    "El Dovio": "76250000",
    "Florida": "76275000",
    "Ginebra": "76306000",
    "Guacari": "76318000",
    "Jamundi": "76364000",
    "La Cumbre": "76377000",
    "La Union": "76400000",
    "La Victoria": "76403000",
    "Obando": "76497000",
    "Palmira": "76520000",
    "Pradera": "76563000",
    "Restrepo": "76606000",
    "Riofrio": "76616000",
    "Roldanillo": "76622000",
    "Sevilla": "76736000",
    "Trujillo": "76828000",
    "Tulua": "76834000",
    "Ulloa": "76845000",
    "Versalles": "76863000",
    "Yotoco": "76890000",
    "Yumbo": "76892000",
    "Zarzal": "76895000"
  },
  "Arauca": {
    "Arauca": "81001000",
    "Arauquita": "81065000",
    "Cravo Norte": "81220000",
    "Fortul": "81300000",
    "Puerto Rondon": "81591000",
    "Saravena": "81736000",
    "Tame": "81794000"
  },
  "Casanare": {
    "Yopal": "85001000",
    "Aguazul": "85010000",
    "Chameza": "85015000",
    "Hato Corozal": "85125000",
    "Monterrey": "85162000",
    "Nunchia": "85225000",
    "Orocue": "85230000",
    "Paz De Ariporo": "85250000",
    "Pore": "85263000",
    "Sabanalarga": "85300000",
    "Sacama": "85315000",
    "San Luis De Palenque": "85325000",
    "Tamara": "85400000",
    "Tauramena": "85410000",
    "Trinidad": "85430000",
    "Villanueva": "85440000",
    "Mani": "85139000"
  },
  "Putumayo": {
    "Mocoa": "86001000",
    "Orito": "86320000",
    "Puerto Asis": "86568000",
    "Puerto Caicedo": "86569000",
    "Puerto Leguizamo": "86573000",
    "Sibundoy": "86749000",
    "San Miguel": "86757000",
    "Valle Del Guamuez La Hormiga": "86865000",
    "Villagarzon": "86885000"
  },
  "San Andres, Providencia": {
    "San Andres": "88001000"
  },
  "Amazonas": {
    "Leticia": "91001000"
  },
  "Guainia": {
    "Inirida": "94001000"
  },
  "Guaviare": {
    "San Jose Del Guaviare": "95001000",
    "Calamar": "95015000",
    "El Retorno": "95025000",
    "Miraflores": "95200000"
  },
  "Vaupes": {
    "Mitu": "97001000"
  },
  "Vichada": {
    "Puerto Carreño": "99001000",
    "La Primavera": "99524000",
    "Santa Rosalia": "99624000",
    "Cumaribo": "99773000"
  }
}